import { fontSize } from "components/report/ChatArea/chatFontSize";
import { colors } from "constants/colors";
import styled, { css } from "styled-components";

export type StyledChatCardProps = {
  reverse?: boolean;
};

export const StyledChatCardContainer = styled.div<StyledChatCardProps>`
  width: 100%;
  display: flex;
  align-items: center;
  @media print {
    break-inside: avoid;
  }
  
// prettier-ignore
   ${({ reverse }) =>
     reverse &&
     css`
       justify-content: flex-end;
     `}
`;

export const StyledChatCard = styled.div<StyledChatCardProps>`
  max-width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0.5rem;

  // prettier-ignore
  ${({ reverse }) =>
    reverse &&
    css`
      flex-flow: row-reverse;
    `}
`;

export const StyledSpeakerNameParagraph = styled.p<StyledChatCardProps>`
  font-size: ${fontSize.r_XSMALL};
  color: ${colors.text};
  
  // prettier-ignore
   ${({ reverse }) =>
     reverse &&
     css`
       text-align: right;
     `}
`;

export const StyledCreatedAtParagraph = styled.p`
  font-size: ${fontSize.r_XSMALL};
  color: ${colors.text};
  align-self: flex-end;
  margin-top: 0.2rem;
`;

export const StyledVerticalArea = styled.div<{ isMyChat?: boolean }>`
  display: flex;
  flex-direction: column;

  gap: ${({ isMyChat }) => (isMyChat ? 0 : "0.4rem")};
`;

export const StyledhorizontalArea = styled.div<StyledChatCardProps>`
  display: flex;
  gap: 0.5rem;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  align-items: flex-end;

  > span {
    margin-bottom: 0.5rem;
    white-space: nowrap;
  }
`;
